export default __webpack_public_path__ + "static/media/check-circle.a8ba6f11.svg";